<main class="login-container" *ngIf="isTokenValid">
  <div class="background-gif"></div>

  <div class="content-wrapper">
    <div class="verification-card">
      <div class="logo-container">
        <img src="assets/images/Logo/login-logo.svg" alt="CSQ Logo" class="logo">
      </div>

      <div *ngIf="isVerified" class="password-reset-content">
        <h1 class="welcome-text">Experience Portal</h1>
        <h2 class="welcome-text">Set New Password</h2>
        <div class="login-subtext">
          Must be at least 8 characters, one special character, and one numeric value
        </div>

        <form [formGroup]="passwordForm" (ngSubmit)="onResetPassword()">
          <!-- Password Field -->
          <!-- Update both password input fields in the template -->

          <!-- Password Field -->
          <div class="password-field">
            <label for="password">New Password</label>
            <div class="password-input-wrapper">
              <div class="input-container">
                <img src="assets/images/lock.svg" alt="password icon" class="icon">
                <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
                  placeholder="Enter Your Password" class="password-input" [class.disabled]="isLoading" [ngClass]="{
          'invalid-input': passwordForm.get('password')?.invalid && passwordForm.get('password')?.touched
        }" (keydown)="preventSpace($event)" (paste)="preventPasteWithSpace($event)" />
              </div>
              <button type="button" class="toggle-password" (click)="togglePasswordVisibility()"
                [class.disabled]="isLoading">
                <i class="fa" [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
              </button>
            </div>
            <div class="login-error-message-container">
              <div class="login-error-message"
                *ngIf="passwordForm.get('password')?.touched && passwordForm.get('password')?.invalid">
                {{ getPasswordErrorMessage() }}
              </div>
            </div>
          </div>

          <!-- Confirm Password Field -->
          <div class="password-field">
            <label for="confirmPassword">Confirm New Password</label>
            <div class="password-input-wrapper">
              <div class="input-container">
                <img src="assets/images/lock.svg" alt="confirm password icon" class="icon">
                <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
                  formControlName="confirmPassword" placeholder="Confirm Your Password" class="password-input"
                  [class.disabled]="isLoading" [ngClass]="{
          'invalid-input': (passwordForm.get('confirmPassword')?.invalid || passwordForm.hasError('mismatch')) && passwordForm.get('confirmPassword')?.touched
        }" (keydown)="preventSpace($event)" (paste)="preventPasteWithSpace($event)" />
              </div>
              <button type="button" class="toggle-password" (click)="toggleConfirmPasswordVisibility()"
                [class.disabled]="isLoading">
                <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
              </button>
            </div>
            <div class="login-error-message-container">
              <div class="login-error-message" *ngIf="passwordForm.get('confirmPassword')?.touched">
                <ng-container *ngIf="passwordForm.get('confirmPassword')?.hasError('required')">
                  Confirm Password is required
                </ng-container>
                <ng-container
                  *ngIf="passwordForm.hasError('mismatch') && !passwordForm.get('confirmPassword')?.hasError('required')">
                  Passwords do not match
                </ng-container>
              </div>
            </div>
          </div>

          <div *ngIf="errorMessage" class="error-message text-center">{{ errorMessage }}</div>

          <button type="submit" class="reset-button" [class.disabled]="isLoading">
            <ng-container *ngIf="!isLoading">Reset Password</ng-container>
            <ng-container *ngIf="isLoading">
              Reset Password <div class="spinner"></div>
            </ng-container>
          </button>
        </form>
      </div>

      <div class="back-link">
        <a href="javascript:void(0)" (click)="backToLogin()" [class.disabled]="isLoading">
          Back to Login
        </a>
      </div>
    </div>
  </div>

  <p class="login-subtext footer-text">
    Should you require immediate assistance, please contact CSQ at
    <a href="tel:1800798488" class="contact-phone">1800 798 488</a> or
    <br>
    email us at <a href="mailto:constructionpathways@csq.org.au"
      class="contact-email">constructionpathways&#64;csq.org.au</a>
  </p>
</main>